<template>
  <div class="content">
    <h1>Join our mailing list</h1>
    <MailingList />
    
  </div>
</template>


<script>
import MailingList from '../components/MailingList'

export default {
  components: {
    MailingList
  },
  head: {
    title() {
      return {
        inner: "Mailing List"
      }
    },
  }
}
</script>
